// extracted by mini-css-extract-plugin
export default {"root":"Typography_root__lXk5p","image":"Typography_image__Po-bo"};